//Snackbar.js
import React, { PureComponent } from "react";
import { StyleSheet, css } from "aphrodite";
import { PropagateLoader } from "react-spinners";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

const styles = {
	loading: {
		position: "relative",
		display: "flex",
		justifyContent: "center",
        padding: "15px",
        marginBottom: "20px"
	}
};

const classes = StyleSheet.create({
	paper: {
		minWidth: "400px",
        maxWidth: "100%",
	}
});

class FullPageLoader extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			open: false,
			title: null,
			msg: null
		};
		FullPageLoader.open = (title = null, msg = null) => {
			this.open(title, msg);
		};
		FullPageLoader.close = () => {
			this.close();
		};
	}

	close() {
		this.setState({ open: false });
	}

	open(title = null, msg = null) {
		if (title === null) title = "Please wait";
		this.setState({ open: true, title: title, msg: msg });
	}

	render() {
		if (this.state.open === false) return null;
		return (
			<Dialog
				open={this.state.open}
				onClose={() => {}}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				classes={{
					paper: css(classes.paper)
				}}
			>
				<DialogTitle id="alert-dialog-title">
					{this.state.title}
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						{this.state.msg}
					</DialogContentText>
					<div style={styles.loading}>
						<PropagateLoader
							color={"#123abc"}
							loading={true}
							size={15}
						/>
					</div>
				</DialogContent>
			</Dialog>
		);
	}
}

export default FullPageLoader;
